/* eslint-disable react/function-component-definition */
import React from 'react';
import Dashboard from '../../dashboard';

const Home = () => <Dashboard />;

export default Home;
